import API_MAP from "../../util/API_MAP";
import API_MANAGER from "../../util/API_MANAGER";

const state = {
	hasData: false, // 是否请求了活动数据
	hotelObj: {}, // 酒店对象
};

const getters = {
	not_finish_hotel: state => {
		const hotelObj = state.hotelObj;
		return !hotelObj.checkin_date || !hotelObj.checkout_date;
	}
};

const actions = {
	// 获取酒店数据
	getHotel({commit, rootState}) {
		let api = API_MAP.HOTEL_INFO;
		let method = 'get';
		let payload = {};
		payload.user_id = rootState.main.currentUser['user_id'];
		let successCb = (data) => {
			commit('setHasData', true);
			commit('setHotel', data);
		};
		let errorCb = () => {

		};
		API_MANAGER({api, method, payload, successCb, errorCb, commit});
	},
	// 提交
	submitHotelInfo({commit, state, rootState}, option) {
		let {data, cb} = option;
		let api = API_MAP.HOTEL_UPDATE;
		let method = 'json';
		let payload = data;
		const hotelId = state.hotelObj.id;
		if (hotelId) {
			payload.id = hotelId;
		}
		payload.user_id = rootState.main.currentUser['user_id'];
		let successCb = () => {
			commit('updateHotel', data);
			cb();
		};
		let errorCb = () => {

		};
		API_MANAGER({api, method, payload, successCb, errorCb, commit});
	}
};

const mutations = {
	// 更新请求状态
	setHasData(state, status) {
		state.hasData = status;
	},
	// 设置酒店信息
	setHotel(state, data) {
		state.hotelObj = data;
	},
	// 更新酒店信息
	updateHotel(state, data) {
		state.hotelObj = Object.assign({}, state.hotelObj, data);
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
